import { observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class DeleteLevelStore implements SaveStateHolder {
  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly levelId: number) {
    makeObservable(this);
    this.save = null;
  }

  complete() {
    if (this.save?.isPending === true)
      return;
    this.save = contentLoaders.x3level.delete(this.levelId);
  }
}
